import { module } from 'stereomodularjs';
import modularLoad from '../utils/load';
import { html } from '../utils/environment';

export default class extends module {
	constructor(m) {
		super(m);
	}

	init() {
		window.scrollTo(0, 0);

		this.linkTarget();

		this.load = new modularLoad({
			enterDelay: 600
		});


		// On link click
		this.load.on('loading', (transition, oldContainer) => {
			classRemove(document.querySelector('html'), 'is-first-load')
			classRemove(document.querySelectorAll('.has-nav-open'), 'has-nav-open')
			classRemove(document.querySelectorAll('.has-search-open'), 'has-search-open')
			classRemove(document.querySelectorAll('.has-overlay-open'), 'has-overlay-open')
			classRemove(document.querySelectorAll('.anims-ready'), 'anims-ready')
			classAdd(document.querySelector('html'), 'is-changing-page')
			this.currentClass = 't-' + document.querySelector('.js-scroll').getAttribute('data-namespace');

			// close all dialogs
			let dialogs = document.querySelectorAll('.js-modal');
			let overlayVideo = document.querySelector('.js-modal-video');
			dialogs.forEach((dialog) => {
				if (dialog.hasAttribute('open')) {
					dialog.setAttribute("closing", "");

					dialog.addEventListener(
						"animationend",
						() => {
							dialog.removeAttribute("closing");
							dialog.close();
							overlayVideo.innerHTML = '';
						},
						{ once: true }
					);
				}
			});
		});

		// On new container enter
		this.load.on('loaded', (transition, oldContainer, newContainer) => {
			classRemove(document.querySelector('body'), this.currentClass)
			this.call('destroy', oldContainer, 'app');
			try {
				setTimeout(() => {
					try {axeptioSDK.initialize();} catch (error) { }
				}, 1000);
			} catch (error) {
				console.error(error);
			}
		});

		// On old container exit
		this.load.on('ready', (transition, newContainer) => {
			this.call('update', newContainer, 'app');
			classAdd(document.querySelector('html'), 'is-loaded')
			classRemove(document.querySelector('html'), 'is-changing-page')
			classAdd(document.querySelector('html'), 'dom-is-loaded')
			classAdd(document.querySelector('body'), 't-' + document.querySelector('.js-scroll').getAttribute('data-namespace'))
			// console.log('ADD CLASS CURRENT PAGE : t-' + document.querySelector('.js-scroll').getAttribute('data-namespace'));
			this.linkTarget();

			setTimeout(() => {
				html.classList.add('anims-ready');
			}, window.transitionDelay);
		});
	}

	goTo(obj) {
		this.load.goTo(obj.url, obj.transition);
	}

	linkTarget() {
		// Add target blank to all external links
		let externalLinks = document.querySelectorAll('a[href^="http"]');
		const isExternalURL = (u) => { try { return new URL(u).origin !== location.origin; } catch (e) { return false; } };
		externalLinks.forEach((link) => {
			if (!isExternalURL(link.href) || link.href.includes('tuxedobillet')) {
				link.setAttribute('target', '_self');
				link.setAttribute('rel', '');
				return;
			}

			link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
            link.classList.add('simple-link-external'); // Ajoute la classe simple-link-external
            var ariaLabel = "Ouvre dans une nouvelle fenêtre";
            if (location.href.match(/\/en\//))
                ariaLabel = "Opens in a new window";
            if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', ariaLabel);
		});

		// Add target blank to all pdf and docx links
		let fileLinks = document.querySelectorAll('a[href$=".pdf"], a[href$=".docx"]');
		fileLinks.forEach((link) => {
			link.setAttribute('target', '_blank');
			var ariaLabel = "Ouvre dans une nouvelle fenêtre";
			if (location.href.match(/\/en\//))
				ariaLabel = "Opens in a new window";
			link.setAttribute('aria-label', ariaLabel);
		});
	}

	destroy() {
		this.modularLoad.destroy();
	}
}
